module.exports = __webpack_public_path__ + "static/media/lapyhome.e223e2ac.svg";